<template>
    <q-dialog v-model="modalComparison"
              persistent
              transition-show="scale"
              transition-hide="scale"
              :maximized="$q.platform.is.mobile">
        <q-card class="modal-comparison">
            <div class="modal-header">
                <span class="modal-title">
                    <span>Товар добавлен в список сравнения</span>
                </span>
                <div class="modal-close" @click.prevent="close()">
                <span aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         x="0px" y="0px" width="10px"
                         height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                        <path d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                    </svg>
                </span>
                </div>
            </div>
            <q-card-actions class="q-pa-md">
                <q-btn color="black" outline @click="close">
                    <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.7904 3.91406H2.38149L4.43708 1.86843C4.66644 1.64015 4.66732 1.26917 4.43904 1.0398C4.21076 0.810408 3.83974 0.809559 3.61038 1.03781L0.548737 4.08468C0.548532 4.08486 0.548385 4.08507 0.548209 4.08524C0.31943 4.31352 0.318698 4.68571 0.548151 4.91475C0.548356 4.91493 0.548502 4.91513 0.548678 4.91531L3.61032 7.96218C3.83965 8.1904 4.21067 8.18961 4.43898 7.96019C4.66726 7.73083 4.66638 7.35984 4.43702 7.13156L2.38149 5.08593H14.7904C15.114 5.08593 15.3764 4.82361 15.3764 4.5C15.3764 4.17638 15.114 3.91406 14.7904 3.91406Z" fill="#6C6C6C"/>
                    </svg>
                    <span> Продолжить покупки</span>
                </q-btn>
                <q-btn color="primary" label="Перейти к сравнению" @click="goToPage" />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
    computed: {
        ...mapState('auth', ['logged']),
        ...mapState('product', ['modalComparison']),
    },
    methods: {
        ...mapMutations('product', ['toggleComparisonModal']),
        close() {
            this.toggleComparisonModal(false);
        },
        login() {
            this.close();
            this.showModal();
        },
        goToPage() {
            window.location.href = '/comparison';
        }
    }
}
</script>

